import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Link } from "@/components/LangLink";
import axios from "axios";
import { toast } from "sonner";
import { tr } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Activate() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error(tr("Passwords do not match"));
      return;
    }
    setBusy(true);
    try {
      await axios.post(`${API}/auth/activate`, { token, new_password: password });
      setDone(true);
    } catch (err) {
      toast.error(err.response?.data?.detail ? tr(err.response.data.detail) : tr("Activation failed"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center px-6" data-testid="activate-page">
      <div className="w-full max-w-md text-center">
        <img src="/logo-gold.png" alt={tr("Delux Concierge")} className="h-16 w-auto mx-auto mb-10" />
        {done ? (
          <div data-testid="activate-success">
            <p className="text-[0.65rem] uppercase tracking-[0.35em] text-gold mb-5">{tr("Account Activated")}</p>
            <h1 className="font-serif text-3xl font-light mb-5">{tr("Welcome to Delux Concierge")}</h1>
            <p className="text-white/60 text-sm font-light leading-relaxed mb-10">{tr("Your member portal is now active. Sign in with your email address and your new password.")}</p>
            <Link
              to="/"
              data-testid="activate-signin-link"
              className="inline-block border border-gold/50 text-gold text-[0.65rem] uppercase tracking-[0.3em] px-8 py-4 hover:bg-gold hover:text-ink transition-colors duration-300"
            >{tr("Continue to Sign In")}</Link>
          </div>
        ) : !token ? (
          <p data-testid="activate-invalid" className="text-white/60 text-sm font-light">{tr("This activation link is invalid. Please use the link from your welcome email.")}</p>
        ) : (
          <form onSubmit={submit} data-testid="activate-form">
            <p className="text-[0.65rem] uppercase tracking-[0.35em] text-gold mb-5">{tr("Member Portal Activation")}</p>
            <h1 className="font-serif text-3xl font-light mb-4">{tr("Set your password")}</h1>
            <p className="text-white/60 text-sm font-light leading-relaxed mb-10">{tr("Choose a secure password for your private member portal. Minimum 8 characters.")}</p>
            <input
              data-testid="activate-password-input"
              type="password"
              required
              minLength={8}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={tr("New Password")}
              className="input-lux mb-6"
            />
            <input
              data-testid="activate-confirm-input"
              type="password"
              required
              minLength={8}
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder={tr("Confirm Password")}
              className="input-lux mb-10"
            />
            <button
              data-testid="activate-submit-btn"
              disabled={busy}
              className="w-full border border-gold/60 text-gold text-[0.65rem] uppercase tracking-[0.3em] py-4 hover:bg-gold hover:text-ink transition-colors duration-300 disabled:opacity-50"
            >
              {busy ? tr("Activating…") : tr("Activate Account")}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
